import { CSSObject } from '@chakra-ui/react';
import { BreadcrumbSchema } from './Breadcrumb.styles';

export const breadcrumbStyles: BreadcrumbSchema = {
  breadcrumbWrapper: {
    borderRadius: 'md',
    px: '4',
    mb: '4',
    h: '8',
    display: 'flex',
    alignItems: 'center',
    bg: '#323368',
    sx: {
      '.chakra-breadcrumb__list': {
        display: 'flex',
      },
      '&::-webkit-scrollbar': { display: 'none' },
    },
  },
  breadcrumbItemBreadcrumb: {
    gap: '1.5',
  },
  breadcrumbLinkItem: {
    textDecoration: 'none',
    color: 'white',
    _hover: {
      textDecoration: 'underline',
    },
    sx: {
      '&:not([href])': {
        textDecoration: 'none',
        color: 'white',
      },
    },
  },
};

export const ChevronRightIcon: CSSObject = {
  color: 'white',
};
